module.exports = __webpack_public_path__ + "static/img/logo-wx.d8faf0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-wx.png
// module id = 9jp+
// module chunks = 1